/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Jump_To_CurrentInputs */

const en_read_along_jump_to_current = /** @type {(inputs: Read_Along_Jump_To_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to current`)
};

const es_read_along_jump_to_current = /** @type {(inputs: Read_Along_Jump_To_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al punto actual`)
};

/**
* | output |
* | --- |
* | "Jump to current" |
*
* @param {Read_Along_Jump_To_CurrentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_jump_to_current = /** @type {((inputs?: Read_Along_Jump_To_CurrentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Jump_To_CurrentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_jump_to_current(inputs)
	return en_read_along_jump_to_current(inputs)
});